import React from 'react';
import '../styles/About.css';

function About() {
  const teamMembers = [
    {
      name: 'Sheela Chouhan',
      role: 'Co-Founder & CEO',
      initials: 'SC',
      email: 'sheela@fortif.app',
      bio: 'Sheela brings over a decade of HR and recruitment experience. After witnessing countless talented candidates overlooked due to flawed screening processes, she envisioned FortIf—an AI solution that makes hiring both smarter and fairer.',
    },
    {
      name: 'Jaykant Kawde',
      role: 'Co-Founder & CTO',
      initials: 'JK',
      email: 'jaykant@fortif.app',
      bio: 'Jaykant is an AI and machine learning expert with a passion for building ethical technology. His expertise in natural language processing and explainable AI forms the technical foundation of FortIf\'s intelligent screening platform.',
    },
  ];

  const whyFortif = [
    {
      icon: '🎯',
      title: 'Context, Not Just Keywords',
      description:
        'Our AI understands the nuances between similar skills and technologies, going far beyond simple keyword matching to find truly qualified candidates.',
    },
    {
      icon: '🔓',
      title: 'Transparent & Explainable',
      description:
        'Every decision is backed by clear explanations. No black box AI—you always know why a candidate was scored a certain way.',
    },
    {
      icon: '⚖️',
      title: 'Built for Fairness',
      description:
        'Designed with bias reduction at its core. Our blind screening mode and fairness metrics ensure equitable hiring practices.',
    },
    {
      icon: '⚡',
      title: 'Recruiter-First Design',
      description:
        'Built by hiring experts for hiring teams. Every feature is designed to save time and improve decision-making, not replace human judgment.',
    },
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title">About FortIf</h2>
          <p className="section-subtitle">
            Revolutionizing recruitment with AI that understands context, ensures fairness, and
            empowers hiring teams.
          </p>
        </div>

        {/* Founder Story */}
        <div className="about-mission">
          <div className="mission-content">
            <h3 className="mission-title">Our Story</h3>
            <p className="mission-text">
              FortIf was born from a simple observation: great candidates were being overlooked by broken hiring systems. Our co-founder and CEO, Sheela Chouhan, spent years in HR witnessing talented individuals rejected simply because their resumes didn't match rigid keyword filters. Meanwhile, biased screening processes continued to perpetuate inequality in the workplace.
            </p>
            <p className="mission-text">
              Determined to solve this problem, Sheela partnered with AI expert Jaykant Kawde to build something better. Together, they created FortIf—an AI-powered platform that truly understands candidates beyond keywords, eliminates bias through transparency, and empowers recruiters to make fair, data-driven decisions. Today, we're helping companies worldwide discover exceptional talent they would have otherwise missed.
            </p>
          </div>
        </div>

        {/* Team Section */}
        <div className="team-section">
          <h3 className="team-title text-center">Meet Our Founders</h3>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-avatar">{member.initials}</div>
                <h4 className="team-name">{member.name}</h4>
                <p className="team-role">{member.role}</p>
                <p className="team-email">
                  <a href={`mailto:${member.email}`}>{member.email}</a>
                </p>
                <p className="team-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Why FortIf */}
        <div className="why-fortif">
          <h3 className="why-title text-center">Why Choose FortIf?</h3>
          <div className="why-grid">
            {whyFortif.map((item, index) => (
              <div key={index} className="why-card">
                <div className="why-icon">{item.icon}</div>
                <h4 className="why-card-title">{item.title}</h4>
                <p className="why-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Values/Stats */}
        <div className="about-stats">
          <div className="stat-item">
            <div className="stat-number">99%</div>
            <div className="stat-label">Screening Accuracy</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">10x</div>
            <div className="stat-label">Faster Hiring</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Explainable AI</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">0</div>
            <div className="stat-label">Bias Tolerance</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
